import { Account } from "models/Account";
import { GET_ACCOUNTS } from "store/actions/Accounts";
import { LOGOUT_USER_ACCOUNT } from "store/actions/Auth";
import { createReducer } from "./Util";

export class AccountState {
    private accounts: { [index: string]: Account } = {};

    public setAccounts(accounts: Account[]) {
        this.accounts = {};
        accounts.forEach(account => this.setAccount(account));
        return this;
    }

    public setAccount(account: Account) {
        this.accounts[account.id] = account;
        return this;
    }

    public getAccountById(id: string): Account | null {
        return this.accounts[id] ?? null;
    }

    public getAccounts(): Account[] {
        return Object.values(this.accounts);
    }
}

const Accounts = createReducer<AccountState>(new AccountState())
    .handle<Account[]>([GET_ACCOUNTS.SUCCESS], (state, payload) => state.setAccounts(payload))
    .handle([LOGOUT_USER_ACCOUNT.SUCCESS], () => new AccountState());

export default Accounts.handler;
